'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState, CSSProperties } from 'react';
import { useTextOverflow } from './useTextOverflow';
import styles from './MarqueeText.module.css';
type MarqueeTextProps = {
  text: string;
  className?: string;
  component: React.ComponentType<any>;
  componentProps?: Record<string, any>;
};
export function MarqueeText(t0) {
  const $ = _c(19);
  const {
    text,
    className: t1,
    component: Component,
    componentProps: t2
  } = t0;
  const className = t1 === undefined ? "" : t1;
  let t3;
  if ($[0] !== t2) {
    t3 = t2 === undefined ? {} : t2;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const componentProps = t3;
  const [bgColor, setBgColor] = useState("#ffffff");
  const {
    ref: containerRef,
    isOverflowing
  } = useTextOverflow();
  let t4;
  if ($[2] !== containerRef) {
    t4 = () => {
      if (containerRef.current) {
        const bgColorStyle = window.getComputedStyle(containerRef.current).backgroundColor;
        setBgColor(bgColorStyle);
      }
    };
    $[2] = containerRef;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = [];
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  useEffect(t4, t5);
  let t6;
  if ($[5] !== bgColor) {
    t6 = {
      "--scroll-duration": "6s",
      "--text-bg-color": bgColor
    };
    $[5] = bgColor;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const containerStyle = t6 as CSSProperties;
  const t7 = `${styles["marquee-inner"]} ${isOverflowing ? styles["is-scrolling"] : ""}`;
  let t8;
  if ($[7] !== Component || $[8] !== className || $[9] !== componentProps || $[10] !== text) {
    t8 = <Component className={className} {...componentProps}>{text}</Component>;
    $[7] = Component;
    $[8] = className;
    $[9] = componentProps;
    $[10] = text;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t7 || $[13] !== t8) {
    t9 = <div data-marquee-inner={true} className={t7}>{t8}</div>;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== containerRef || $[16] !== containerStyle || $[17] !== t9) {
    t10 = <div ref={containerRef} className={`${styles["marquee-track"]} ${styles["marquee-fade"]}`} style={containerStyle}>{t9}</div>;
    $[15] = containerRef;
    $[16] = containerStyle;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
}